import { render, staticRenderFns } from "./unusedCharger.vue?vue&type=template&id=136513ca&"
import script from "./unusedCharger.vue?vue&type=script&lang=js&"
export * from "./unusedCharger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports